import React from 'react';

const Guide = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5 4H5.5V20H15.5V16H19.5V4ZM5.5 2C4.39543 2 3.5 2.89543 3.5 4V20C3.5 21.1046 4.39543 22 5.5 22H15.6716C16.202 22 16.7107 21.7893 17.0858 21.4142L20.9142 17.5858C21.2893 17.2107 21.5 16.702 21.5 16.1716V4C21.5 2.89543 20.6046 2 19.5 2H5.5ZM16.5 12H8.5V10H16.5V12ZM8.5 9H16.5V7H8.5V9ZM12.5 15H8.5V13H12.5V15Z"
    />
  </svg>
);

export default Guide;
